import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PageLayout } from './component';
import MsalWrapper from './msal-wrapper';
import { DataHealth, InternalUser, Map, NotFound, PortStateControl, VesselList } from './pages';
import { configService } from './service';

const App = () => {
    const [msalInstance, setMsalInstance] = useState();

    const azureB2CInstance = new PublicClientApplication({ auth: configService.azureB2CMsal.auth, cache: configService.azureB2CMsal.cache });
    const azureAdInstance = new PublicClientApplication({ auth: configService.azureAdMsal.auth, cache: configService.azureAdMsal.cache });

    useEffect(() => {
        if (!msalInstance) {
            const params = new URLSearchParams(window.location.search);
            const impersonatedUser = params.get('impersonatedUser');

            if (window.location.href.includes('internal') || sessionStorage.getItem('isInternal') === 'true') {
                sessionStorage.setItem('isInternal', 'true');
                if (impersonatedUser && impersonatedUser !== '') {
                    sessionStorage.setItem('impersonatedUser', impersonatedUser);
                }

                setMsalInstance(azureAdInstance);
            } else {
                sessionStorage.setItem('isInternal', 'false');
                setMsalInstance(azureB2CInstance);
            }
        }
    }, [msalInstance, azureAdInstance, azureB2CInstance]);

    return (
        <>
            {msalInstance && (
                <MsalProvider instance={msalInstance}>
                    <MsalWrapper>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<PageLayout />}>
                                    <Route index element={<Map />} />
                                    <Route path="vessel" element={<VesselList />} />
                                    <Route path="data" element={<DataHealth />} />
                                    <Route path="port-state-control" element={<PortStateControl />} />
                                    <Route path="internal" element={<InternalUser />} />
                                </Route>
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </BrowserRouter>
                    </MsalWrapper>
                </MsalProvider>
            )}
        </>
    );
};

export default App;
